var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoulder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shoulder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shoulder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3509294,32.1221623 C19.0892563,30.9860135 18.7012297,29.7263042 18.0471231,27.4535026 C17.9159908,28.3501234 17.6799652,29.3654575 17.3390465,30.4995051 C17.2289164,30.865847 17.0025207,31.4756488 16.777283,32.0796182 L8.91318165,31.9895137 C9.11214252,31.3056244 9.32234269,30.5967525 9.54378215,29.8628981 C10.2347037,27.2957049 10.6962808,25.2202896 10.9285134,23.6366523 C11.160746,22.053015 11.3910687,19.4102371 11.6194815,15.7083186 C11.503338,12.9311521 12.023148,10.7092875 13.1789116,9.04272488 C14.3346752,7.37616224 15.8978024,6.59451862 17.8682933,6.69779399 C18.4998542,6.57243352 18.9569272,6.46895813 19.2395123,6.38736784 C19.66339,6.26498239 21.7361541,5.11876449 22.5198269,4.75426632 C23.3034998,4.38976815 25.2001825,3.84056725 26.0185943,3.3798341 C26.837006,2.91910094 27.9902135,1.81194899 27.9902135,0.030537927 L32,0.030537927 L32,31.9895137 L19.3509294,32.1221623 Z",
    id: "Path",
    fill: "#8596A1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "18.2370212 23.6180664 18.0552251 28.192707 32.4992169 26.5827878 32.5552251 23.6180664"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "18.2509708 25.9986257 16 6.61138018 13.0462518 8.59201463 17.8791386 25.9986257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    strokeLinejoin: "round",
    points: "13.1120644 8.70568094 11.4932419 12.4963648 18.0702691 27.0559315 18.2509708 20.6218249"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    strokeLinejoin: "round",
    points: "11.58858 13.1632896 11.0883749 18.7423704 18.0702691 28.192707 18.2509708 25.9986257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    strokeLinejoin: "round",
    points: "10.9106089 19.4078025 10.5552251 24.2969797 18.0702691 28.192707 18.0702691 26.6492867"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    strokeLinejoin: "round",
    points: "20.4221781 5.68370319 16.0797636 6.56452477 18.0702691 27.0559315 18.2509708 27.0559315"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoulder);
export default __webpack_public_path__ + "static/media/Shoulder.cdfceb7f37fbad6ba7ba5f975634c39f.svg";
export { ForwardRef as ReactComponent };